import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Image,
  useColorScheme,
  TextInput,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const ExperienceSharingScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [activeTab, setActiveTab] = useState('experiences');
  const [searchText, setSearchText] = useState('');

  // 模拟经验分享数据
  const experiences = [
    {
      id: 'e1',
      title: '我的低碳饮食减重历程',
      content: '分享我通过低碳饮食三个月成功减重10公斤的经验和心得，包括饮食安排、注意事项和心理调适...',
      tags: ['减重', '低碳饮食', '健康生活'],
      user: {
        name: '李健康',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      },
      likes: 128,
      comments: 36,
      time: '2天前',
    },
    {
      id: 'e2',
      title: '无糖生活一个月的变化',
      content: '一个月前我决定完全戒掉精制糖，分享这一个月来的身体变化和感受，以及我是如何克服糖瘾的...',
      tags: ['无糖生活', '健康饮食', '习惯养成'],
      user: {
        name: '小丽',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      },
      likes: 95,
      comments: 28,
      time: '上周',
    },
    {
      id: 'e3',
      title: '如何科学补充蛋白质',
      content: '作为一名健身教练，我想分享一些关于如何科学补充蛋白质的建议，包括每日摄入量、最佳时机和优质蛋白来源...',
      tags: ['蛋白质', '健身', '营养摄入'],
      user: {
        name: '健身教练',
        avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
      },
      likes: 156,
      comments: 42,
      time: '2周前',
    },
  ];

  // 模拟食谱分享数据
  const recipes = [
    {
      id: 'r1',
      title: '高蛋白低脂早餐碗',
      content: '这款早餐碗富含蛋白质，低脂肪，能量充足，非常适合健身人群或减脂期间食用...',
      image: 'https://images.unsplash.com/photo-1494390248081-4e521a5940db?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
      tags: ['高蛋白', '低脂', '早餐'],
      user: {
        name: '营养师小王',
        avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
      },
      likes: 187,
      saves: 76,
      time: '3天前',
      nutrition: {
        calories: 320,
        protein: 28,
        carbs: 32,
        fat: 8,
      }
    },
    {
      id: 'r2',
      title: '地中海风格烤鱼',
      content: '这道菜采用地中海风格烹饪，富含Omega-3脂肪酸，对心血管健康非常有益...',
      image: 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
      tags: ['地中海饮食', '烤鱼', '晚餐'],
      user: {
        name: '美食达人',
        avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
      },
      likes: 142,
      saves: 58,
      time: '上周',
      nutrition: {
        calories: 280,
        protein: 26,
        carbs: 18,
        fat: 12,
      }
    },
  ];

  // 渲染搜索栏
  const renderSearchBar = () => {
    return (
      <View style={{ 
        flexDirection: 'row',
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 12,
        padding: 10,
        marginBottom: 16,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <Ionicons name="search" size={20} color={isDarkMode ? '#d1d5db' : '#9ca3af'} style={{ marginRight: 8 }} />
        <TextInput
          style={{ 
            flex: 1,
            color: isDarkMode ? 'white' : '#1f2937',
            fontSize: 16,
          }}
          placeholder={activeTab === 'experiences' ? "搜索健康经验..." : "搜索健康食谱..."}
          placeholderTextColor={isDarkMode ? '#9ca3af' : '#9ca3af'}
          value={searchText}
          onChangeText={setSearchText}
        />
        {searchText !== '' && (
          <TouchableOpacity onPress={() => setSearchText('')}>
            <Ionicons name="close-circle" size={20} color={isDarkMode ? '#d1d5db' : '#9ca3af'} />
          </TouchableOpacity>
        )}
      </View>
    );
  };

  // 渲染经验分享卡片
  const renderExperienceCard = (experience) => {
    return (
      <TouchableOpacity
        key={experience.id}
        style={{ 
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}
        onPress={() => navigation.navigate('ExperienceDetail', { experienceId: experience.id })}
      >
        {/* 用户信息 */}
        <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
          <Image 
            source={{ uri: experience.user.avatar }} 
            style={{ 
              width: 40, 
              height: 40, 
              borderRadius: 20,
              marginRight: 12, 
            }} 
          />
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 2,
            }}>
              {experience.user.name}
            </Text>
            <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {experience.time}
            </Text>
          </View>
        </View>

        {/* 内容 */}
        <Text style={{ 
          fontSize: 18,
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
          marginBottom: 8,
        }}>
          {experience.title}
        </Text>
        <Text style={{ 
          fontSize: 14,
          color: isDarkMode ? '#d1d5db' : '#4b5563',
          marginBottom: 12,
        }}>
          {experience.content}
        </Text>

        {/* 标签 */}
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 }}>
          {experience.tags.map((tag, index) => (
            <View 
              key={index}
              style={{
                backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
                marginRight: 8,
                marginBottom: 8,
              }}
            >
              <Text style={{ 
                fontSize: 12, 
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                #{tag}
              </Text>
            </View>
          ))}
        </View>

        {/* 互动栏 */}
        <View style={{ 
          flexDirection: 'row', 
          borderTopWidth: 1, 
          borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
          paddingTop: 12,
        }}>
          <View style={{ 
            flexDirection: 'row', 
            alignItems: 'center', 
            marginRight: 16,
          }}>
            <Ionicons 
              name="heart" 
              size={20} 
              color="#ec4899" 
              style={{ marginRight: 4 }}
            />
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {experience.likes}
            </Text>
          </View>
          <View style={{ 
            flexDirection: 'row', 
            alignItems: 'center',
          }}>
            <Ionicons 
              name="chatbubble-outline" 
              size={18} 
              color={isDarkMode ? '#d1d5db' : '#6b7280'} 
              style={{ marginRight: 4 }}
            />
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {experience.comments}
            </Text>
          </View>
          <View style={{ flex: 1, alignItems: 'flex-end' }}>
            <TouchableOpacity style={{ padding: 4 }}>
              <Ionicons 
                name="share-social-outline" 
                size={20} 
                color={isDarkMode ? '#d1d5db' : '#6b7280'} 
              />
            </TouchableOpacity>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  // 渲染食谱卡片
  const renderRecipeCard = (recipe) => {
    return (
      <TouchableOpacity
        key={recipe.id}
        style={{ 
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 16,
          marginBottom: 16,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
          overflow: 'hidden',
        }}
        onPress={() => navigation.navigate('RecipeDetail', { recipeId: recipe.id })}
      >
        {/* 食谱图片 */}
        <Image 
          source={{ uri: recipe.image }} 
          style={{ 
            width: '100%', 
            height: 180,
          }} 
        />

        {/* 内容区域 */}
        <View style={{ padding: 16 }}>
          {/* 用户信息 */}
          <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
            <Image 
              source={{ uri: recipe.user.avatar }} 
              style={{ 
                width: 36, 
                height: 36, 
                borderRadius: 18,
                marginRight: 12, 
              }} 
            />
            <View style={{ flex: 1 }}>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
                marginBottom: 2,
              }}>
                {recipe.user.name}
              </Text>
              <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                {recipe.time}
              </Text>
            </View>
          </View>

          {/* 食谱标题和内容 */}
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 8,
          }}>
            {recipe.title}
          </Text>
          <Text style={{ 
            fontSize: 14,
            color: isDarkMode ? '#d1d5db' : '#4b5563',
            marginBottom: 12,
          }}>
            {recipe.content}
          </Text>

          {/* 营养信息 */}
          <View style={{ 
            flexDirection: 'row', 
            backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
            borderRadius: 8,
            padding: 10,
            marginBottom: 12,
          }}>
            <View style={{ flex: 1, alignItems: 'center' }}>
              <Text style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                fontSize: 12,
                marginBottom: 2,
              }}>
                热量
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {recipe.nutrition.calories} kcal
              </Text>
            </View>
            <View style={{ flex: 1, alignItems: 'center' }}>
              <Text style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                fontSize: 12,
                marginBottom: 2,
              }}>
                蛋白质
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {recipe.nutrition.protein}g
              </Text>
            </View>
            <View style={{ flex: 1, alignItems: 'center' }}>
              <Text style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                fontSize: 12,
                marginBottom: 2,
              }}>
                碳水
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {recipe.nutrition.carbs}g
              </Text>
            </View>
            <View style={{ flex: 1, alignItems: 'center' }}>
              <Text style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                fontSize: 12,
                marginBottom: 2,
              }}>
                脂肪
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {recipe.nutrition.fat}g
              </Text>
            </View>
          </View>

          {/* 标签 */}
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 }}>
            {recipe.tags.map((tag, index) => (
              <View 
                key={index}
                style={{
                  backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                  borderRadius: 20,
                  marginRight: 8,
                  marginBottom: 8,
                }}
              >
                <Text style={{ 
                  fontSize: 12, 
                  color: isDarkMode ? '#e0e0e0' : '#4b5563',
                }}>
                  #{tag}
                </Text>
              </View>
            ))}
          </View>

          {/* 互动栏 */}
          <View style={{ 
            flexDirection: 'row', 
            borderTopWidth: 1, 
            borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
            paddingTop: 12,
          }}>
            <View style={{ 
              flexDirection: 'row', 
              alignItems: 'center', 
              marginRight: 16,
            }}>
              <Ionicons 
                name="heart" 
                size={20} 
                color="#ec4899" 
                style={{ marginRight: 4 }}
              />
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                {recipe.likes}
              </Text>
            </View>
            <View style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
              marginRight: 16,
            }}>
              <Ionicons 
                name="bookmark" 
                size={18} 
                color="#8b5cf6" 
                style={{ marginRight: 4 }}
              />
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                {recipe.saves}
              </Text>
            </View>
            <View style={{ flex: 1, alignItems: 'flex-end' }}>
              <TouchableOpacity style={{ padding: 4 }}>
                <Ionicons 
                  name="share-social-outline" 
                  size={20} 
                  color={isDarkMode ? '#d1d5db' : '#6b7280'} 
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View 
      style={{ 
        flex: 1,
        backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      }}
    >
      <View style={{ padding: 16 }}>
        {/* 标签切换 */}
        <View style={{ 
          flexDirection: 'row',
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 12,
          padding: 4,
          marginBottom: 16,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}>
          <TouchableOpacity 
            style={{ 
              flex: 1,
              paddingVertical: 10,
              alignItems: 'center',
              borderRadius: 10,
              backgroundColor: activeTab === 'experiences' 
                ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
                : 'transparent',
            }}
            onPress={() => setActiveTab('experiences')}
          >
            <Text style={{ 
              color: activeTab === 'experiences' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
              fontWeight: activeTab === 'experiences' ? 'bold' : 'normal',
            }}>
              健康心得
            </Text>
          </TouchableOpacity>
          
          <TouchableOpacity 
            style={{ 
              flex: 1,
              paddingVertical: 10,
              alignItems: 'center',
              borderRadius: 10,
              backgroundColor: activeTab === 'recipes' 
                ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
                : 'transparent',
            }}
            onPress={() => setActiveTab('recipes')}
          >
            <Text style={{ 
              color: activeTab === 'recipes' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
              fontWeight: activeTab === 'recipes' ? 'bold' : 'normal',
            }}>
              健康食谱
            </Text>
          </TouchableOpacity>
        </View>

        {/* 搜索栏 */}
        {renderSearchBar()}

        {/* 发布按钮 */}
        <TouchableOpacity
          style={{ 
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 12,
            padding: 12,
            marginBottom: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}
          onPress={() => navigation.navigate(activeTab === 'experiences' ? 'CreateExperience' : 'CreateRecipe')}
        >
          <View style={{
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: '#2563eb',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 12,
          }}>
            <Ionicons name="create" size={20} color="white" />
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontSize: 16,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 2,
            }}>
              {activeTab === 'experiences' ? '分享您的健康心得' : '分享您的健康食谱'}
            </Text>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              {activeTab === 'experiences' ? '与社区分享您的健康经验' : '分享美味又健康的食谱'}
            </Text>
          </View>
          <Ionicons name="chevron-forward" size={24} color={isDarkMode ? '#d1d5db' : '#9ca3af'} />
        </TouchableOpacity>

        {/* 内容区域 */}
        <ScrollView showsVerticalScrollIndicator={false}>
          {activeTab === 'experiences' ? (
            experiences.map((experience) => renderExperienceCard(experience))
          ) : (
            recipes.map((recipe) => renderRecipeCard(recipe))
          )}
        </ScrollView>
      </View>
    </View>
  );
};

export default ExperienceSharingScreen; 